<template>
    <div class="vendor-terms-of-service-modal">
        <md-dialog class="vendor-terms-of-service-modal-dialog" ref="dialog">
            <md-dialog-content>
                <vendor-terms-of-service></vendor-terms-of-service>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>
<script>
import VendorTermsOfService from "@/components/Vendor/VendorTermsOfService";
export default {
    components: {
        VendorTermsOfService
    },
    methods: {
        open() {
            this.$refs["dialog"].open();
        },
        close() {
            this.$refs["dialog"].close();
        }
    }
};
</script>
<style lang="less">
.vendor-terms-of-service-modal-dialog {
    .md-dialog-content {
        padding: 0;
    }
    .md-card {
        margin: 0;
    }
}
</style>